import { css } from 'styled-components';
var indexes = {
  base: 0,
  low: 1,
  medium: 2,
  high: 3,
  higher: 4
};

var zIndex = function zIndex(index) {
  var value = indexes.base;

  if (index) {
    value = indexes[index];
  }

  return css(["z-index:", ";"], value);
};

export default zIndex;